"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadDocument = exports.saveStatus = exports.saveConsent = exports.saveCoDeed = exports.removeCoDeed = exports.getHelocStatus = exports.getDisclosures = exports.getCoDeeds = exports.downloadDocument = exports.UPLOAD_DOCUMENT = exports.SAVE_STATUS = exports.SAVE_CO_DEED = exports.SAVE_CONSENT = exports.REMOVE_CO_DEED = exports.GET_HELOC_STATUS = exports.GET_HELOC_CO_DEED_DISCLOSURES = exports.GET_CO_DEEDS = exports.DOWNLOAD_DOCUMENT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var _env = require("../env");

var DOWNLOAD_DOCUMENT = 'DOWNLOAD_HELOC_CO_DEED_DOCUMENT';
exports.DOWNLOAD_DOCUMENT = DOWNLOAD_DOCUMENT;
var GET_HELOC_STATUS = 'GET_HELOC_CO_DEED_STATUS';
exports.GET_HELOC_STATUS = GET_HELOC_STATUS;
var GET_CO_DEEDS = 'GET_HELOC_CO_DEEDS';
exports.GET_CO_DEEDS = GET_CO_DEEDS;
var GET_HELOC_CO_DEED_DISCLOSURES = 'GET_HELOC_CO_DEED_DISCLOSURES';
exports.GET_HELOC_CO_DEED_DISCLOSURES = GET_HELOC_CO_DEED_DISCLOSURES;
var SAVE_CO_DEED = 'SAVE_HELOC_CO_DEED';
exports.SAVE_CO_DEED = SAVE_CO_DEED;
var REMOVE_CO_DEED = 'REMOVE_HELOC_CO_DEED';
exports.REMOVE_CO_DEED = REMOVE_CO_DEED;
var SAVE_CONSENT = 'SAVE_HELOC_CO_DEED_CONSENT';
exports.SAVE_CONSENT = SAVE_CONSENT;
var SAVE_STATUS = 'SAVE_HELOC_CO_DEED_STATUS';
exports.SAVE_STATUS = SAVE_STATUS;
var UPLOAD_DOCUMENT = 'UPLOAD_HELOC_CO_DEED_DOCUMENT';
exports.UPLOAD_DOCUMENT = UPLOAD_DOCUMENT;
var CONTEXT = _env.isMerchant ? '/app-merloc/secure/api/v1/application/heloc' : '/service-application/api/v1/application/heloc';

var getHelocStatus = function getHelocStatus() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_HELOC_STATUS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/co-deed/status"), null, null, false));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getHelocStatus = getHelocStatus;

var getCoDeeds = function getCoDeeds(helocUuid) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxGet)(GET_CO_DEEDS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(helocUuid, "/co-deed"), null, {
                helocUuid: helocUuid
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getCoDeeds = getCoDeeds;

var getDisclosures = function getDisclosures(helocUuid, coDeedUuid) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(GET_HELOC_CO_DEED_DISCLOSURES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(helocUuid, "/co-deed/disclosure"), null, {
                coDeedUuid: coDeedUuid
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getDisclosures = getDisclosures;

var downloadDocument = function downloadDocument(helocUuid, documentUuid) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(DOWNLOAD_DOCUMENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(helocUuid, "/co-deed/disclosure/document/").concat(documentUuid, "/download"), {
                responseType: 'arraybuffer'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
}; // { helocUuid, name, address, email, phoneNumber, ssn, additionalSigner, customerRelationship, coDeedIdentityUuid? }


exports.downloadDocument = downloadDocument;

var saveCoDeed = function saveCoDeed(data) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxPut)(SAVE_CO_DEED, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(data.helocUuid, "/co-deed"), data));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
}; // { helocUuid, coDeedIdentityUuid }


exports.saveCoDeed = saveCoDeed;

var removeCoDeed = function removeCoDeed(data) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (0, _ajax.ajaxPut)(REMOVE_CO_DEED, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(data.helocUuid, "/co-deed/remove"), data));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
}; // { helocUuid, coDeedIdentityUuid, type, version }


exports.removeCoDeed = removeCoDeed;

var saveConsent = function saveConsent(data) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (0, _ajax.ajaxPut)(SAVE_CONSENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(data.helocUuid, "/co-deed/consent"), data));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
}; // { helocUuid, status }


exports.saveConsent = saveConsent;

var saveStatus = function saveStatus(data) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", (0, _ajax.ajaxPut)(SAVE_STATUS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(data.helocUuid, "/co-deed/status/").concat(data.status)));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
}; // { helocUuid, coDeedIdentityUuid, type, file, countryCode }


exports.saveStatus = saveStatus;

var uploadDocument = function uploadDocument(data, onProgress) {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(dispatch) {
      var form;
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              form = new FormData(); // eslint-disable-line new-cap

              form.append('coDeedIdentityUuid', data.coDeedIdentityUuid);
              form.append('type', data.type);
              form.append('file', data.file);
              if (data.countryCode) form.append('countryCode', data.countryCode);
              return _context9.abrupt("return", (0, _ajax.formPost)(UPLOAD_DOCUMENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(data.helocUuid, "/co-deed/document/upload"), form, data, onProgress));

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};

exports.uploadDocument = uploadDocument;